
import React from 'react'
import '../styles/_current_accordances.scss';
import { useTranslation } from 'react-i18next';
import { HeaderPmr } from '../../components/HeaderPmr/HeaderPmr';
import { capitalizeFirstLetter } from '../../../../../services/stringUtil';
import { HeaderTCDI } from '../../components/HeaderTCDI/HeaderTCDI';
import { mapGeneralInfoInDataSource } from '../../utils/Helpers/MapperHelper';
import { formatDate } from '../../utils/Helpers/DataFormatHelper';
import { NoContentView } from '../../components/NoContentView/NoContentView';

export const CurrentAccordancesSection = ({ data }) => {
    const { t } = useTranslation();

    return (
        <section className='current-accordances-report'>
            {data.isPMRType ? <HeaderPmr data={mapGeneralInfoInDataSource(data)} /> : <HeaderTCDI data={mapGeneralInfoInDataSource(data)} />}
            <article className="current-accordances-info-report">
                <h3 className='content-layout-title'>{capitalizeFirstLetter(t('new_current_agreements'))} ({data.accordancesCount})</h3>
                <section className='current-accordances-info-layout'>
                    <div className='current-accordances-content'>
                        {
                            data.currentAccordances.length ? <table>
                                <thead>
                                    <tr>
                                        <th className='header-title'>{t('extended_report.accordance_origin')}</th>
                                        <th className='header-title'>{t('critical_issue')}</th>
                                        <th className='header-title'>{capitalizeFirstLetter(t('description_of_the_agreement'))}</th>
                                        <th className='header-title'>{t('extended_report.followup_bid')}</th>
                                        <th className='header-title'>{t('expiration')}</th>
                                        <th className='header-title'>{t('last_comment')}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.currentAccordances.map((accordance, index) => (
                                        <tr key={`accordance_${index}`}>
                                            <td className='accordance-content chart-title'>{accordance.accordancesTypeName}</td>
                                            <td className='accordance-content'>{accordance.criticalIssuesName}</td>
                                            <td className='accordance-content'>{accordance.descriptionAccordances}</td>
                                            <td className='accordance-content'>{accordance.personInChargeName}</td>
                                            <td className='accordance-content'>{formatDate(accordance.expirationDate)}</td>
                                            <td className='accordance-content'>
                                                <span className='comments-text'>{accordance.comment || ''}</span><br />
                                                {accordance.comment && (<span className='comment-detail'>{formatDate(accordance.dateComment)} · {accordance.nameAuthor}</span>)}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            : <NoContentView title={t('last_no_information')} description={t('no_active_accordance')} />
                        }
                    </div>
                </section>
            </article>
        </section >
    );
};
